import React, { useRef, useState } from "react";
import { DrawerRight, DrawerTrigger } from "@/components/ui/drawer";
import SvgRightCaret from "../../../assets/icons/SvgCaretDown";

import CheckboxDrawer from "./CheckboxDrawer";
import PriceDrawer from "./PriceDrawer";
import {
  AVAILIBILITY,
  COLORS,
  IN_STOCK,
  OUT_OF_STOCK,
  SIZES,
  VENDORS,
} from "../constants";
import { useDispatch, useSelector } from "react-redux";
import UseColors from "../../../staticQueries/useColors";
import { getColors } from "../../../utils/getColors";
import { setSortBy } from "../../../slices/filter";

const MENU_PROPS = "cursor-pointer py-[10px] flex items-center justify-between";

const CARET_ICON_STYLES = {
  position: "absolute",
  right: "20px",
  width: "12px",
  height: "12px",
  transform: "rotate(270deg)",
};

const MobileFilter = ({ handleClearAll, colors, sizes }) => {
  const { filter, sortBy } = useSelector((state) => state.filter);
  const btnRef = useRef();
  const dispatch = useDispatch();
  const [drawer, setDrawer] = useState("home");
  const colorsNames = UseColors();
  const matchedColors = getColors(colors, colorsNames);

  async function handleSelect(e) {
    dispatch(setSortBy(e.target.value));
  }
  return (
    <DrawerRight className="max-w-[85%] md:max-w-sm w-full flex flex-col">
      <div className="text-sm text-center border-b border-solid border-b-[rgb(242,242,242)] h-fit px-6 py-4">
        <h6 className="font-semibold">Filter</h6>
      </div>
      <div className="relative w-full h-full px-6 py-2 grow">
        <div className="flex flex-col py-5 bg-full bg-center">
          <p
            className={MENU_PROPS}
            role="button"
            onClick={() => setDrawer("price")}
          >
            Price
            <SvgRightCaret style={CARET_ICON_STYLES} />
          </p>

          <p
            className={MENU_PROPS}
            role="button"
            onClick={() => setDrawer("color")}
          >
            Color
            <SvgRightCaret style={CARET_ICON_STYLES} />
          </p>
          <p
            className={MENU_PROPS}
            role="button"
            onClick={() => setDrawer("size")}
          >
            Size
            <SvgRightCaret style={CARET_ICON_STYLES} />
          </p>
          <p className={MENU_PROPS} role="button">
            Sort by:
            <div className="relative max-w-fit-content border-b border-solid border-b-black">
              <select
                className="border-none focus:outline-none bg-transparent text-sm h-6 appearance-none pr-6"
                value={sortBy}
                onChange={handleSelect}
              >
                <option value="featured">Featured</option>
                <option value="price_h">Price, low to high</option>
                <option value="price_l">Price, high to low</option>
              </select>
              <div className="absolute top-1/2 right-0 transform -translate-y-1/2">
                <SvgRightCaret className="w-3 h-3 -rotate-90" />
              </div>
            </div>
          </p>
        </div>
        <PriceDrawer isOpen={drawer === "price"} setDrawer={setDrawer} />
        <CheckboxDrawer
          isOpen={drawer === "color"}
          title="Color"
          checkBoxes={matchedColors.map((color, index) => {
            return {
              title: color.name,
              key: COLORS,
              name: color.name,
              isSelected: filter.colors.includes(color.name),
            };
          })}
          setDrawer={setDrawer}
        />
        {typeof sizes === "object" && (
          <CheckboxDrawer
            isOpen={drawer === "size"}
            title="Size"
            checkBoxes={Object.entries(sizes)?.map(([size, counts], index) => {
              return {
                title: size + " (" + counts + ")",
                key: SIZES,
                name: size,
                isSelected: filter.sizes?.includes(size),
              };
            })}
            setDrawer={setDrawer}
          />
        )}
      </div>
      <div className="relative border-t border-solid border-t-[rgb(242,242,242)] h-fit px-6 py-4 text-right z-[1]">
        <button onClick={handleClearAll}>
          <DrawerTrigger
            className="bg-transparent hover:text-secondary-500 underline underline-offset-4 cursor-pointer text-sm mr-12 font-bold"
            asChild
          >
            <span>Clear all</span>
          </DrawerTrigger>
        </button>
        <button>
          <DrawerTrigger
            asChild
            className="bg-[#1f1f1f] text-white text-sm rounded-full px-[35px] py-3"
          >
            <span>Apply</span>
          </DrawerTrigger>
        </button>
      </div>
    </DrawerRight>
  );
};

export default MobileFilter;
